import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Autocomplete,
} from '@mui/material';
import {
  dialogPaperSx,
  dialogTitleSx,
  dialogSecondaryBtnSx,
} from '../../theme/themedSx';

function capitalizeWords(text) {
  if (!text) return '';
  return text.replace(/\b\w/g, (c) => c.toUpperCase());
}

function idEq(a, b) {
  return a != null && b != null && (a === b || String(a) === String(b));
}

/**
 * DBA process status change — shared by underwriting, pending, complete, sales DBA lists.
 */
export default function DbaStatusChangeDialog({
  open,
  onClose,
  onConfirm,
  selectedDba,
  statusOptions = [],
  value,
  onChange,
  processingId,
  title = 'Change DBA Status',
  confirmLabel = 'Change Status',
  description,
}) {
  const selected =
    statusOptions.find((s) => idEq(s.id, value)) || null;
  const busy = processingId && selectedDba && idEq(processingId, selectedDba.id);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={dialogPaperSx}>
      <DialogTitle sx={dialogTitleSx}>{title}</DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <DialogContentText sx={{ mb: 2, color: 'grey.700' }}>
          {description ??
            `Update the status for ${selectedDba?.name || 'this DBA'}. Select a new status below.`}
        </DialogContentText>
        <Autocomplete
          options={statusOptions}
          getOptionLabel={(option) => capitalizeWords(option?.name || '')}
          value={selected}
          onChange={(_, newValue) => onChange(newValue ? newValue.id : '')}
          isOptionEqualToValue={(opt, val) => idEq(opt?.id, val?.id)}
          renderInput={(params) => (
            <TextField {...params} label="Change the DBA status to" fullWidth />
          )}
          sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={dialogSecondaryBtnSx}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={!value || busy}
          startIcon={busy ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
